<div class="form-subcontainer" [class]="{ 'popup-mode': popupMode }">
  <div class="form-content">
    <div>
      <form class="fpx-form-group">
        <div>
          <ng-container *ngIf="_commonService.isMobile()">
            <section class="header-sec">
              <div class="header-grp">
                <button class="btn" clickable (click)="onClickBackBtn()">
                  <img src="./assets/images/back-arrow.svg" />
                </button>
                <h3 class="fpx-sec-title">
                  {{ "CONTEXTULAMENU.beneficiaryTitle" | translate }}
                </h3>
              </div>
            </section>
          </ng-container>

          <section class="search-bene-grp">
            <div class="search-bar-bene">
              <input
                id="beneSearch"
                type="text"
                placeholder="{{'PAYMENTS.BENEFICIARY.placeholder' | translate}}"
                (input)="onBeneSearch($event.target.value)"
              />
            </div>
            <div class="search-filter-option" *ngIf="!_beneficiaryService.isBeneListEmpty">
              <div class="bene-list-filters">
                <div
                  class="bene-all active"
                  (click)="chooseFilter($event, 'all')"
                >
                  ({{ allBeneList?.length }}){{"PAYMENTS.BENEFICIARY.all" | translate}}
                </div>
                <div class="bene-fav" (click)="chooseFilter($event, 'fav')">
                  ({{ favBeneList?.length }}){{"PAYMENTS.BENEFICIARY.favourite" | translate}}
                </div>
                <ng-container *ngIf="additionalDetails.fromNav == 'manageBene'">
                  <div class="bene-fav" (click)="chooseFilter($event, 'INTBT')">
                    ({{ intbtBeneList?.length }}){{"PAYMENTS.BENEFICIARY.withInBank_filter" | translate}}
                  </div>
                  <div class="bene-fav" (click)="chooseFilter($event, 'ACH')">
                    ({{ achBeneList?.length }}){{"PAYMENTS.BENEFICIARY.domestic_filter" | translate}}
                  </div>
                  <div class="bene-fav" (click)="chooseFilter($event, 'SWIFT')">
                    ({{ swiftBeneList?.length }}){{"PAYMENTS.BENEFICIARY.international_filter" | translate}}
                  </div>
                  <!-- <div class="bene-fav" (click)="chooseFilter($event,'SEPA')">({{ sepaBeneList?.length }})SEPA</div> -->
                </ng-container>
              </div>
              <!-- <div class="bene-filter-icon">
                <button type="button" class="button-filter">
                  <span>filter</span>
                </button>
              </div> -->
            </div>
          </section>
          <section>
            <ng-container *ngFor="let item of beneGrpList; index as i">
              <div class="alphabet-grp">{{ item.group }}</div>
              <ng-container *ngFor="let bene of item.children; index as j">
                <div class="bene-list-item">
                  <app-beneficiary-list-detail
                    [isTransfer] = "isTransfer"
                    [bene]="bene"
                    [fromAccountNumber]="fromAccountNumber"
                    [popupMode]="popupMode"
                    (emitDeleteEvent)="refreshBeneList($event)"
                    [index]="bene.beneId"
                    [additionalDetails]="additionalDetails"
                  ></app-beneficiary-list-detail>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!beneGrpList || beneGrpList.length == 0">
              <!-- <div class="not-found">No result found</div> -->
              <div class="not-found">
                <div class="not-found-image">
                  <img src="./assets/images/empty-transactions.svg" id="leftImg" alt="image1" />
                </div>
                <div class="no-bene-text">{{'PAYMENTS.BENECARDLIST.noDataAvailable'| translate}}</div>
                <div class="fav-button-container">
                  <button type="button" class="btn-primary" (click)="createBene()">{{'FORM_ACTIONS.add_bene'| translate}}</button>
                </div>
              </div>
              
    
            </ng-container>
          </section>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- <button type="button" clickable (click)="addBene()" class="btn-more btn-sticky">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.971"
    height="24.969"
    viewBox="0 0 24.971 24.969"
  >
    <g
      id="Group_10713"
      data-name="Group 10713"
      transform="translate(-4351.854 3678.479) rotate(-45)"
    >
      <line
        id="Line_325"
        data-name="Line 325"
        x2="12"
        y2="12"
        transform="translate(5672.304 487.804)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-width="4"
      />
      <line
        id="Line_326"
        data-name="Line 326"
        x1="12"
        y2="12"
        transform="translate(5672.304 487.804)"
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-width="4"
      />
    </g>
  </svg>
</button> -->
